import { Popup } from '@approvalmax/ui';
import { ui } from 'modules/common';
import { memo, useState } from 'react';
import bemFactory from 'react-bem-factory';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { saveAndApproveRequest } from '../actions';
import { isLoading } from '../selectors/pageSelectors';
import { messages } from './SaveAndApprovePopup.messages';

const Content = styled.div`
    padding: 10px 60px 40px 80px;
    border-top: 1px solid #ebeaea;
`;

const Description = styled.div`
    margin-top: 10px;
`;

const CommentEditor = styled(ui.AddCommentEditor)`
    margin-top: 50px;
`;

const qa = bemFactory.qa('reqf-save-and-approve-popup');

const SaveAndApprovePopup = () => {
    const dispatch = useDispatch();
    const [commentText, setCommentText] = useState('');
    const loading = useSelector(isLoading);

    const onDone = () => {
        dispatch(saveAndApproveRequest({ skipPreconditions: true, commentText }));
    };

    return (
        <Popup.DefaultContent
            qa={qa()}
            title={messages.popupTitle}
            buttons={
                <Popup.DefaultContent.Button
                    qa={qa('done-button')}
                    execute={onDone}
                    disabled={loading}
                    title={messages.doneButtonTitle}
                >
                    {messages.doneButtonText}
                </Popup.DefaultContent.Button>
            }
        >
            <Content>
                <Description>{messages.description}</Description>

                <Description>{messages.commentNote}</Description>

                <CommentEditor
                    qa={qa('comment-editor')}
                    focusOnMount
                    value={commentText}
                    onChange={(commentText) => setCommentText(commentText)}
                />
            </Content>
        </Popup.DefaultContent>
    );
};

export default memo(SaveAndApprovePopup);
